import { ButtonRoot } from '@/components/common/Button'
import { FloatingTooltip } from '@/components/common/Floating'
import { Icon } from '@/components/icons/Icon'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type IconType } from '@/defs/icon'

import styles from './TableColumnHeader.module.scss'

export type TableSortActionType = 'apply' | 'reverse' | 'reset'

type Props = {
  icon?: IconType
  isSortable: boolean
  isSortby: boolean
  label: string
  onClick?: (action: TableSortActionType) => void
  shouldShortenLabel?: boolean
  sortbyDirection?: 'asc' | 'desc'
}

export const TableColumnHeader = ({
  icon,
  isSortable,
  isSortby,
  label,
  onClick: onClickProp,
  shouldShortenLabel,
  sortbyDirection,
}: Props) => {
  const onClick = () => onClickProp?.(isSortby ? (sortbyDirection === 'desc' ? 'reverse' : 'reset') : 'apply')

  const labelFullElement = <IconWithLabel iconBefore={icon}>{label}</IconWithLabel>

  const buttonElement = (
    <ButtonRoot as={!isSortable ? 'div' : undefined} onClick={isSortable ? onClick : undefined}>
      <IconWithLabel
        iconAfter={isSortby && (sortbyDirection === 'desc' ? 'arrowDown' : 'arrowUp')}
        iconAfterMargin='sm'
        iconAfterSize='sm'
      >
        {shouldShortenLabel ? (
          <>
            <span className={styles.labelLong}>{labelFullElement}</span>
            <span className={styles.labelShort}>
              {icon ? (
                <>
                  <Icon name={icon} />
                  <span className='visually-hidden'>{label}</span>
                </>
              ) : (
                labelFullElement
              )}
            </span>
          </>
        ) : (
          labelFullElement
        )}
      </IconWithLabel>
    </ButtonRoot>
  )

  const tooltipContent =
    isSortby && sortbyDirection === 'asc'
      ? 'Reset sort by'
      : `Sort by ${label} (${isSortby ? 'Ascending' : 'Descending'})`

  return isSortable ? (
    <FloatingTooltip content={<IconWithLabel iconBefore={icon}>{tooltipContent}</IconWithLabel>}>
      {buttonElement}
    </FloatingTooltip>
  ) : (
    buttonElement
  )
}
